export class AppSettings {
    public static base_url = 'https://rp.esquall.com/api/';
 
}